"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATA_VALUE_NAMES = exports.EPopularityPeriod = void 0;
var EPopularityPeriod;
(function (EPopularityPeriod) {
  EPopularityPeriod[EPopularityPeriod["day"] = 10] = "day";
  EPopularityPeriod[EPopularityPeriod["week"] = 20] = "week";
  EPopularityPeriod[EPopularityPeriod["month"] = 30] = "month";
  EPopularityPeriod[EPopularityPeriod["year"] = 40] = "year";
})(EPopularityPeriod = exports.EPopularityPeriod || (exports.EPopularityPeriod = {}));
exports.DATA_VALUE_NAMES = ['created_at', 'updated_at', 'deleted_at'];
